import { useSuspenseQuery } from '@tanstack/react-query';

import { Content } from '@/core/components';

import { ProofAction } from '@feature/proof/ProofAction';
import { ProofUploadRequest } from '@feature/proof/ProofTypes';
import { Author, Id } from '@feature/utils';

import {
  getProceedingProofsOptions,
  useDeleteProceedingProof,
  useUploadOrUpdateProceedingProof,
} from './model/ProceedingProofModel';

interface ProceedingProofActionProps {
  proceedingId: number;
  authors: Author[];
  variant?: 'compact';
}

export function ProceedingProofAction({ proceedingId, authors }: ProceedingProofActionProps) {
  const { data: proofs } = useSuspenseQuery(getProceedingProofsOptions(proceedingId));
  const uploadOrUpdateMutation = useUploadOrUpdateProceedingProof(proceedingId);
  const deleteMutation = useDeleteProceedingProof(proceedingId);

  const handleUpload = (request: ProofUploadRequest) => {
    uploadOrUpdateMutation.mutate(request);
  };

  const handleDelete = (proofId: Id) => {
    deleteMutation.mutate(proofId);
  };

  return (
    <Content type="full">
      <ProofAction
        proofs={proofs}
        entity="proceeding"
        onUpload={handleUpload}
        onDelete={handleDelete}
        isPending={uploadOrUpdateMutation.isPending || deleteMutation.isPending}
        authors={authors}
      />
    </Content>
  );
}
